module.exports = __webpack_public_path__ + "img/9788932915241.64233d53.jpg";